import { render, staticRenderFns } from "./studentInfoCertificationRecord_3.vue?vue&type=template&id=6fcd702a&scoped=true"
import script from "./studentInfoCertificationRecord_3.vue?vue&type=script&lang=js"
export * from "./studentInfoCertificationRecord_3.vue?vue&type=script&lang=js"
import style0 from "./studentInfoCertificationRecord_3.vue?vue&type=style&index=0&id=6fcd702a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcd702a",
  null
  
)

export default component.exports